import React, { useState, useEffect } from 'react';
import { DownOutlined } from '@ant-design/icons';
import './styles.less';

//to change
const ScrollToBottomButton = ({ scrollableDivId }: { scrollableDivId: string }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollableDiv = document.getElementById(scrollableDivId);
    if (scrollableDiv) {
      const isAtBottom = scrollableDiv.scrollHeight - scrollableDiv.scrollTop === scrollableDiv.clientHeight;
      setIsVisible(!isAtBottom);
    }
  };

  const scrollToBottom = () => {
    const scrollableDiv = document.getElementById(scrollableDivId);
    if (scrollableDiv) {
      scrollableDiv.scrollTo({
        top: scrollableDiv.scrollHeight,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const scrollableDiv = document.getElementById(scrollableDivId);
    if (scrollableDiv) {
      scrollableDiv.addEventListener('scroll', handleScroll);
      return () => scrollableDiv.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <div className={`scroll-to-bottom-btn ${isVisible ? 'visible' : ''}`} onClick={scrollToBottom}>
      <DownOutlined className="scroll-to-bottom-btn-icon" />
    </div>
  );
};

export default ScrollToBottomButton;
